import { mapState, mapMutations } from 'vuex';
import { validationFormMixin } from '../../../shared/mixins/validationFormMixin';
import {
  fetchExpenseCategory,
  updateExpenseCategory,
  createExpenseCategory,
  deleteExpenseCategory,
} from '../../helpers/knExpenseOption';
import KnFormSubtitle from '../../../shared/components/KnFormSubtitle/KnFormSubtitle.vue';
import KnFormActionButtons from '../../../shared/components/KnFormActionButtons/KnFormActionButtons.vue';
import { paginationMixin } from '@/modules/shared/mixins/paginationMixin';
import KnListWithActions from '../../../shared/components/KnListWithActions/KnListWithActions.vue';

export default {
  components: {
    KnFormSubtitle,
    KnFormActionButtons,
    KnListWithActions,
  },
  mixins: [paginationMixin, validationFormMixin],
  data() {
    return {
      errors: [],
      valid: true,
      expenseCategory: {
        id: 'NA', // No aplica
        dato: null,
        id_autor: null,
        id_institucion_educativa: null,
      },
      expenseCategories: [],
      toUpdate: false,
      showInactive: false,
      loading: false,
    };
  },
  async created() {
    this.setIsLogin(false);
    await this.getPaginatedExpenseCategory(1);
    this.expenseCategory.id_autor = this.userData.id;
    this.expenseCategory.id_institucion_educativa = this.institutionId;
    //this.expenseCategories = await fetchExpenseCategoryByEI(this.institutionId);
  },
  computed: {
    ...mapState(['institutionId', 'userData']),
    actionTitle() {
      return this.toUpdate ? 'Actualizar' : 'Crear';
    },
    invalidFields() {
      return this.objectHasNulls(this.expenseCategory);
    },
  },
  watch: {
    showInactive: {
      async handler() {
        await this.getPaginatedExpenseCategory(1);
      },
    },
    institutionId: {
      async handler() {
        this.setIsLogin(false);
        await this.getPaginatedExpenseCategory(1);
        this.expenseCategory.id_autor = this.userData.id;
        this.expenseCategory.id_institucion_educativa = this.institutionId;
      },
    },
  },
  methods: {
    ...mapMutations(['setIsLogin']),
    async getPaginatedExpenseCategory(page = 1) {
      try {
        this.expenseCategories = [];
        this.setPaginationPage(page);

        if (!this.loading) {
          this.loading = true;

          const { ok, data, message, count } = await fetchExpenseCategory({
            institutionId: this.institutionId,
            systemStatus: !this.showInactive,
            limit: this.pagination.limit,
            offset: this.pagination.offset,
          });

          if (ok) {
            this.setPaginationCount(count);
            for (const expense of data) {
              this.expenseCategories.push({ ...expense });
            }
          } else {
            console.error(
              'No se pudieron obtener los egresos por categorias',
              message
            );
          }

          this.loading = false;
        }
      } catch (error) {
        console.error('Error al obtener los egresos por categorias:', error);
        this.loading = false;
      }
    },
    async save() {
      await createExpenseCategory(
        this.expenseCategory.dato,
        this.expenseCategory.id_autor,
        this.expenseCategory.id_institucion_educativa
      );
      await this.getPaginatedExpenseCategory(1);
      this.clear();
    },
    clear() {
      this.expenseCategory = {
        id: 'NA',
        dato: null,
        id_autor: this.userData.id,
        id_institucion_educativa: this.institutionId,
      };
      this.toUpdate = false;
      this.$refs.form.resetValidation();
    },
    clearInline() {
      this.expenseCategory = {
        id: 'NA',
        dato: null,
        id_autor: this.userData.id,
        id_institucion_educativa: this.institutionId,
      };
      this.toUpdate = false;
      this.$refs.form.resetValidation();
    },
    async updateInline(item) {
      this.expenseCategory = { ...item };
      await updateExpenseCategory(
        this.expenseCategory.id,
        this.expenseCategory.dato,
        this.expenseCategory.id_autor,
        this.expenseCategory.id_institucion_educativa
      );
      await this.getPaginatedExpenseCategory(1);
      this.clearInline();
    },
    async deleteInline(itemId) {
      await deleteExpenseCategory(itemId);
      await this.getPaginatedExpenseCategory(1);
      //this.expenseCategories = fetchExpenseCategoryByEI(this.institutionId);
      this.clearInline();
    },
  },
};
